import { render } from "./PageGuard.vue?vue&type=template&id=b950e2ac&scoped=true&ts=true&lang=html"
import script from "./PageGuard.vue?vue&type=script&lang=ts"
export * from "./PageGuard.vue?vue&type=script&lang=ts"

import "./PageGuard.vue?vue&type=style&index=0&id=b950e2ac&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b950e2ac"]])

export default __exports__